import { v4 as uuidv4 } from 'uuid';
import { MEDIA_TYPES } from '../../constants';

const runtimeMedia = new Map();

function revokePreviewUrl(entry) {
  if (entry?.previewUrl) {
    URL.revokeObjectURL(entry.previewUrl);
  }
}

function create(arrayBuffer, metadata = {}) {
  if (!arrayBuffer || !(arrayBuffer instanceof ArrayBuffer)) {
    throw new TypeError('mediaRuntimeCache.create expects ArrayBuffer');
  }

  const mediaBlobOrFile = new Blob([arrayBuffer]);
  const id = metadata.id || uuidv4();
  const previewUrl = URL.createObjectURL(mediaBlobOrFile);
  const mediaType = detectType(metadata.contentType);
  const mimeType = metadata.contentType;

  const entry = {
    ...metadata,
    id,
    blob: mediaBlobOrFile,
    previewUrl,
    mediaType,
    mimeType,
    size: mediaBlobOrFile.size || 0,

    fileName: metadata.fileName,
    requestId: metadata.requestId,
    actionType: metadata.actionType,
    time: metadata.time,
  };

  const previous = runtimeMedia.get(id);
  if (previous) {
    revokePreviewUrl(previous);
  }

  runtimeMedia.set(id, entry);

  return {
    id: entry.id,
    previewUrl: entry.previewUrl,
    mediaType: entry.mediaType,
    size: entry.size,
    requestId: entry.requestId,
    actionType: entry.actionType,
    time: entry.time,
    fileName: entry.fileName,
  };
}

function get(id) {
  return runtimeMedia.get(id) || null;
}

function getBlob(id) {
  return runtimeMedia.get(id)?.blob || null;
}

function remove(id) {
  const entry = runtimeMedia.get(id);
  if (!entry) return false;

  revokePreviewUrl(entry);
  runtimeMedia.delete(id);
  return true;
}

function clear() {
  runtimeMedia.forEach((entry) => {
    revokePreviewUrl(entry);
  });

  runtimeMedia.clear();
}

function has(id) {
  return runtimeMedia.has(id);
}

function size() {
  return runtimeMedia.size;
}

const mediaRuntimeCache = {
  create,
  get,
  getBlob,
  remove,
  clear,
  has,
  size,
};

function detectType(type) {
  if (type.startsWith('image/')) {
    return MEDIA_TYPES.IMAGE;
  }
  if (type.startsWith('video/')) {
    return MEDIA_TYPES.VIDEO;
  }

  return MEDIA_TYPES.APPLICATION;
}

export default mediaRuntimeCache;
export { create, get, getBlob, remove, clear, has, size };
